import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useResponsive } from '#core/SdgQuiz/utils';

type SdgCategoryHeaderProps = {
  title: string;
  backgroundColor: string;
  color: string;
};

export const SdgCategoryHeader = ({
  title,
  backgroundColor,
  color,
}: SdgCategoryHeaderProps) => {
  const isMobileScreen = useResponsive();

  return (
    <Flex
      backgroundColor={backgroundColor}
      fontWeight="bold"
      color={color}
      borderRadius={50}
      width="100%"
      justifyContent="center"
      textAlign="center"
      fontSize={isMobileScreen ? 'md' : '2xl'}
      py={isMobileScreen ? 2 : 1}
      mt={isMobileScreen ? 10 : 12}
      mb={isMobileScreen ? 7 : 10}
    >
      {title}
    </Flex>
  );
};
